export default "__VITE_ASSET__DbBYJHAa__"